/**
 * Riconosce URL YouTube/Vimeo in qualunque formato comune (watch?v=, youtu.be,
 * shorts, studio.youtube.com/video/ID/edit, vimeo.com/ID, player.vimeo.com/video/ID)
 * e costruisce l'URL embed per un video di sfondo "ambient": autoplay, muto,
 * in loop, senza controlli — stesso ruolo visivo delle immagini di sfondo
 * nelle slide, non un player con cui l'utente interagisce.
 *
 * Include apposta studio.youtube.com/video/ID/edit — l'URL della pagina di
 * editing in YouTube Studio, non un formato di condivisione pubblico, ma
 * quello su cui capita di finire subito dopo aver caricato un video (bug
 * reale trovato in uso: un admin l'ha incollato pensando fosse il link del
 * video, il player restava vuoto senza errori perché l'URL non veniva
 * riconosciuto).
 */
export function parseVideoUrl(url) {
  if (!url) return null;
  const trimmed = url.trim();

  const yt = trimmed.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|studio\.youtube\.com\/video\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (yt) return { provider: 'youtube', id: yt[1] };

  const vimeo = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return { provider: 'vimeo', id: vimeo[1] };

  return null;
}

export function backgroundEmbedUrl({ provider, id }) {
  if (provider === 'youtube') {
    // loop=1 su YouTube richiede playlist=<stesso id> per ripetere un
    // singolo video (limite noto dell'embed API, non un refuso). cc_load_policy=0
    // disattiva i sottotitoli automatici mostrati di default sull'embed —
    // per un video di sfondo "ambient" non hanno senso (nessuno li legge,
    // stanno solo sopra al video).
    return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&modestbranding=1&playsinline=1&rel=0&iv_load_policy=3&disablekb=1&cc_load_policy=0`;
  }
  // background=1 è il parametro Vimeo pensato apposta per questo uso — muto,
  // loop, senza controlli, senza bisogno di comporli a mano come per YouTube.
  return `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&loop=1&background=1&controls=0`;
}
